import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import { useIntl } from 'react-intl';

import { canUserViewShareDetails } from '../helpers/Share';
import {
  getTabUrlParam,
  updateTabUrlParam,
} from '../helpers';

import AdminBackUrl from '../components/Admin/BackUrl';
import ShareDetailsTabs from '../components/Admin/ShareDetails/ShareDetailsTabs';
import ShareDetailsTabContent from '../components/Admin/ShareDetails/ShareDetailsTabContent';

const ShareDetails = ({ match }) => {
  const intl = useIntl();

  const [activeTab, setActiveTab] = useState(getTabUrlParam() || 'collected-details');

  const handleSwitchTab = (tab) => {
    setActiveTab(tab);
    updateTabUrlParam(tab);
  };

  if (!canUserViewShareDetails()) {
    return null;
  }

  return (
    <div className="main-content">
      <Container fluid>
        <AdminBackUrl urls={[{ url: '/share-links', label: intl.formatMessage({ defaultMessage: 'Share links' }) }]} />
        <header className="page-header">
          <h2 className="page-title">
            <i className="far fa-circle-info" />
            {intl.formatMessage({ defaultMessage: 'Share link details' })}
          </h2>
        </header>
        <div className="content-wrapper">
          <ShareDetailsTabs
            handleSwitchTab={handleSwitchTab}
            activeTab={activeTab}
          />
          <ShareDetailsTabContent
            shareUuid={match.params.shareUuid}
            activeTab={activeTab}
          />
        </div>
      </Container>
    </div>
  );
};

ShareDetails.propTypes = {
  match: PropTypes.object.isRequired,
};

export default ShareDetails;
